import { RequestState } from "vuex-fetch-factory";
import { OrganisationModel } from "modules/relationprofile/models";
import { PrivatePersonModel } from "../models/privatePerson";
import { FileEntryModel } from "../models/fileEntry";

export interface StateInterface {
  vuexFetchersState: Map<string, Map<string, RequestState>>;
  organisation: OrganisationModel;
  privatePerson: PrivatePersonModel;
  fileEntries: FileEntryModel[];
}

const state: StateInterface = {
  vuexFetchersState: new Map(),
  organisation: new OrganisationModel(),
  privatePerson: new PrivatePersonModel(),
  fileEntries: [],
};

export default state;
